<template>
  <p>

    <a @click="htmledit('<b>','</b>',kacinci)"><img src="https://www.sinnav.com/admin-panel/gorunum/img/ed/kalin.gif" alt="" width="24"/></a>
    <a @click="htmledit('<u>','</u>',kacinci)"><img src="https://www.sinnav.com/admin-panel/gorunum/img/ed/cizgi.gif" alt="" width="24"/></a>
    <a @click="htmledit('<sup>','</sup>',kacinci)"><img src="https://www.sinnav.com/admin-panel/gorunum/img/ed/ust.gif" alt="" width="24"/></a>
    <a @click="htmledit('<sub>','</sub>',kacinci)"><img src="https://www.sinnav.com/admin-panel/gorunum/img/ed/alt.gif" alt="" width="24"/></a>
    <a @click="htmlekle(kacinci,'&radic;')"><img src="https://www.sinnav.com/admin-panel/gorunum/img/ed/kok.gif" alt="" width="24"/></a>
    <a @click="preview=!preview"><i class="fa fa-code" :style="'margin-left: 10px;width: 24px; height:24px;color:'+(preview?'gray':'black')"></i></a>
  </p>
  <Textarea v-if="!preview"   :model="data" name="textareas" :id="'textarea'+kacinci"  :title="'Soru: '+kacinci"  @datachanged="dataChanged(kacinci,$event)" placeholder="Soru Girin"/>
  <div v-if="preview" v-html="data" style="white-space: pre-line"></div>
</template>

<script>
import Textarea from '@/components/forms/Textarea'
export default {
  name: 'Question',
  components: {
    Textarea
  },
  data () {
    return {
      data: this.model,
      preview: false
    }
  },
  methods: {
    dataChanged (kacinci, data) {
      this.data = data
      this.$emit('datachanged', this.data, 'textareas')
    },
    htmledit (bir, iki, index) {
      const textarea = document.getElementById('textarea' + index)
      const baslangic = textarea.selectionStart
      const son = textarea.selectionEnd
      const secili = textarea.value.substring(baslangic, son)
      if (secili.length > 0) {
        const uzunluk = textarea.value.length
        const basmetin = textarea.value.substring(0, baslangic)
        const sonmetin = textarea.value.substring(son, uzunluk)
        const birlestir = basmetin + bir + secili + iki + sonmetin
        this.data = birlestir
        this.dataChanged(index, birlestir)
        this.setCaretToPos(document.getElementById('textarea' + index), parseInt(son) + parseInt(bir.length) + parseInt(iki.length))
      }
    },
    setCaretToPos (input, pos) {
      this.setSelectionRange(input, pos, pos)
    },
    setSelectionRange (input, selectionStart, selectionEnd) {
      if (input.setSelectionRange) {
        input.focus()
        input.setSelectionRange(selectionStart, selectionEnd)
      } else if (input.createTextRange) {
        var range = input.createTextRange()
        range.collapse(true)
        range.moveEnd('character', selectionEnd)
        range.moveStart('character', selectionStart)
        range.select()
      }
    },
    htmlekle (index, w) {
      const textarea = document.getElementById('textarea' + index)
      const cursorPosition = this.getCaret(textarea)
      const leftText = textarea.value.substring(0, cursorPosition)
      const rightText = textarea.value.substring(cursorPosition, textarea.value.length)
      this.data = leftText + w + rightText
      this.dataChanged(index, leftText + w + rightText)
      this.setCaretToPos(document.getElementById('textarea-' + index), parseInt(cursorPosition) + w.length)
    },
    getCaret (el) {
      if (el.selectionStart) {
        return el.selectionStart
      } else if (document.selection) {
        el.focus()

        var r = document.selection.createRange()
        if (r == null) {
          return 0
        }

        var re = el.createTextRange()
        var rc = re.duplicate()
        re.moveToBookmark(r.getBookmark())
        rc.setEndPoint('EndToStart', re)

        return rc.text.length
      }
      return 0
    }
  },
  props: {
    model: {
      type: String,
      required: true
    },
    kacinci: {
      required: true
    }
  },
  watch: {
    model: function (data) {
      this.data = data
    }
  }
}
</script>
